import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss']
})
export class HeadingComponent implements OnInit {
 @Input() title = '';
  @Input() size = 28;
  @Input() color;

  constructor() { }

  ngOnInit(): void {
  }

}
